import { httpClient } from '../http/httpClient'

export const removeTable = async (id: string) => {
  const { data } = await httpClient.delete(`/table/${id}`)

  return data
}
